import { cva, type VariantProps } from 'class-variance-authority';

import { cn } from '@/utils';

const skeletonVariants = cva('animate-pulse rounded-md', {
  variants: {
    variant: {
      foreground: 'bg-foreground',
      background: 'bg-background',
    },
  },
  defaultVariants: {
    variant: 'foreground',
  },
});

type SkeletonProps = React.HTMLAttributes<HTMLDivElement> & VariantProps<typeof skeletonVariants>;

function Skeleton({ className, variant, ...props }: SkeletonProps) {
  return <div className={cn(skeletonVariants({ variant, className }), 'animate-pulse rounded-md')} {...props} />;
}

export { Skeleton };
